import { Toolbar } from '@mui/material'
import Logo from '../../../assets/logo.png';
import './Header.css';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export const Header = (props) => {
  const navigate = useNavigate();
  const { instance,accounts } = useMsal();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    instance?.logoutRedirect();
  }
  return (
    <div className="main-header" ref={props?.headerRef}>
      <Toolbar className='toolbar_header'>
        <div className="main-box">
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 14, textAlign: 'right' }}>
              <span>{accounts?.[0]?.name}</span>
              <span onClick={handleLogout} style={{cursor:'pointer'}}>Logout</span>
            </div>
          </div>

        </div>
      </Toolbar>
      <div className='gradient_section'>
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {process.env.REACT_APP_ENV === "dev" ?
            "Development Environment - This is not Production. Use only for testing & development"
            : process.env.REACT_APP_ENV === "sit" ?
              "SIT Environment - This is not Production. Use only for system integration testing"
              : process.env.REACT_APP_ENV === "uat" ?
                "UAT Environment - This is not Production. Use only for user acceptance testing"
                : process.env.REACT_APP_ENV === "prod" ?
                  ""
                  : ""}
        </span>
      </div>
    </div>
  );
}